<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getNetworkTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button
          v-if="permissionNetwork && permissionNetwork.permission_id === permission.readWrite"
          @click.native="createNetwork" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
                <template v-if="header.icon">
                  <a @click="sortDataTable">
                    <v-icon class="fas fa-caret-down"
                            v-if="sort_order == 'desc'"
                            style="font-size: 12px"></v-icon>
                    <v-icon class="fas fa-caret-up"
                            v-if="sort_order == 'asc'"
                            style="font-size: 12px"></v-icon>
                  </a>
                </template>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataTable" :key="item.network_id">
              <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
              <td>{{ item.name_th }}</td>
              <td>{{ item.updated_at | moment("DD-MM-YYYY") }}</td>
              <td>{{ item.orders }}</td>
              <td>
                <a @click="showNetworkData(item.network_id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
import InputSearch from "../../../components/Input/InputSearch";
import CircleButton from "../../../components/Button/CircleButton";
import IconPencil from "../../../components/Icon/icon-pencil";
import Paginate from "../../../components/Layout/Paginate";
import {permissionNetwork, role} from "../../../util/Permission";
import Swal from 'sweetalert';
import Loading from 'vue-loading-overlay';

export default {
  name: "NetworkTable",
  components: {Paginate, IconPencil, CircleButton, InputSearch, Loading},
  computed:{
    permissionNetwork,
  },
  data() {
    return {
      title: "Network",
      isLoading: false,
      headers: [
        { id: 1, text: "No." ,icon : null},
        { id: 2, text: "Name" ,icon : null},
        { id: 3, text: "Update date" ,icon : null},
        { id: 4, text: "Order" ,icon : true},
        { id: 5, text: "Edit" ,icon : null}
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      },
      permission : null,
      search : '',
      sort_order : 'desc',
    };
  },
  created() {
    this.permission = role;
    this.getNetworkTable(1);
  },
  methods: {
    getNetworkTable(page) {
      this.isLoading = true;
      this.$store.dispatch("Network/getNetwork", {
        page,
        search : this.search,
        sort_order : this.sort_order
      }).then(res => {
        if (res.response_code === 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    async changePage(val){
      this.isLoading = true;
      this.dataPaginate.current_page = val;
      await this.getNetworkTable(this.dataPaginate.current_page);
      this.isLoading = false;
    },
    goToNetworkEdit() {
      this.$router.push("/network/edit");
    },
    showNetworkData(id) {
      this.isLoading = true;
      this.$store.dispatch("Network/showNetwork", id).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("Network/setFormNetwork", res.result).then(() => {
            this.goToNetworkEdit();
          });
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    createNetwork() {
      this.$store.dispatch("Network/clearFormData").then(() => {
        this.goToNetworkEdit();
      });
    },
    searchInput(val){
      this.search = val;
    },
    sortDataTable(){
      this.sort_order = this.sort_order == 'desc' ? 'asc' : 'desc';
      this.getNetworkTable(1);
    }
  }
};
</script>

<style scoped>
@import "../../../assets/css/table.css";
.branch-data {
  background-color: transparent;
  margin: 20px;
}
</style>
